import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="heading, text" width="100%" theme="lightest" alignment="yes" className="py-0 text-align-left div-p-0 left-content" mdxType="TextBlock" />
    <h2 {...{
      "id": "need-more-information"
    }}>{`Need More Information?`}</h2>
    <p>{`The Adobe PDF Services API can help automate PDF generation, manipulation and transformation of content with a set of simple-to-use cloud-based operations`}</p>
    <TextBlock slots="text" width="100%" theme="lightest" alignment="yes" paddingTop="5" paddingBottom='5' className="py-0 div-p-0 left-content" mdxType="TextBlock" />
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Create PDFs from any Microsoft 365 document, HTML pages or image files`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Convert PDFs to a number of file formats`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Extract text, tables, images, and document structure from PDFs`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Generate PDFs and word documents from Word templates and JSON data`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Combine PDFs into a single document`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Apply OCR to create an editable PDF from a scanned file`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Password Protect PDF documents`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Compress PDF documents`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Organize PDF documents by inserting, re-ordering, deleting, rotating pages`}</p>
      </li>
    </ul>
    <TextBlock slots="text" width="100%" theme="lightest" alignment="yes" paddingTop="5" paddingBottom='5' className="py-0 div-p-0 left-content" mdxType="TextBlock" />
    <p>{`Use this form to have an Adobe representative contact you to about any questions you may have or explain pricing options or point you to helpful resources.`}</p>
    <TextBlock slots="text" width="100%" theme="lightest" alignment="yes" paddingTop="5" paddingBottom='5' className="py-0 div-p-0 left-content" mdxType="TextBlock" />
    <p>{`You can also find more information in the `}<a title="FAQ Link" href="https://www.adobe.com/go/dcsdk_forum">{`FAQ`}</a>{` for the PDF Services API.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      